import { FC, useEffect, useRef, useState } from "react";
import sliderimg from "../../../frontend/styles/images/cnbc-default-image.webp";
import GetData from "../../services/GetData";
import { requests, fileUrl } from '../../services/Requests';
import Link from 'next/link';
import CategoriesLinks from "../Shared/CategoriesLinks/CategoriesLinks";
import VideoDuration from "../HelperComponents/VideoDuration";
import TimeAgoArabicFormat from "../Shared/TimeAgoCustom/TimeAgoArabicFormat";
import Title from "../Title";
import Thumbnail from "../Thumbnail";
// import { Swiper, SwiperSlide } from 'swiper/react';
// import { Navigation, Pagination } from 'swiper';
import { Swiper, SwiperSlide ,Navigation,Pagination} from 'apps/frontend/components/SwiperClient/SwiperClient';
import { buildNewsRoute } from "apps/frontend/services/Util";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';


const MostWatchedSlider: FC<any> = () => {
    const [mostWatchedNewsList, setMostWatchedNewsList] = useState<any>({});
    
    useEffect(() => {
        GetData(`${requests.mostWatchedNews}&limit=10&offset=0`, {}, 'get', false).then(res => {
            const mostWatchedNews = res.data?.response ? res.data?.response : {}
            setMostWatchedNewsList(mostWatchedNews);

        }).catch(err => {
            console.warn(err)
        })

    }, [])

    const navigationPrevRef = useRef(null);
    const navigationNextRef = useRef(null);

    return (
        <>
            <div className="newsSliderText newsSlider2Text video_newsSlider_wrap">
                <div className=" heading_border mt-5">
                    <div className="row">
                        <div className="col-sm-6">
                            <div className="float-end">
                                <Title styles={"yellowTitle"}>
                                    <h3>الأكثر مشاهدة</h3>
                                </Title>
                            </div>
                        </div>
                        <div className="col-sm-6">
                            <div className="sliderArrows text-start">
                                <button
                                    className="slider-arrow arrow-prev"
                                    ref={navigationPrevRef}
                                >
                                    Previous
                                </button>
                                <button
                                    className="slider-arrow arrow-next"
                                    ref={navigationNextRef}
                                >
                                    Next
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <Swiper
                    navigation={{
                        prevEl: navigationPrevRef.current,
                        nextEl: navigationNextRef.current,
                    }}
                    dir="rtl"
                    slidesPerView={4}
                    spaceBetween={20}
                    slidesPerGroup={1}
                    breakpoints={{
                        '1024': { slidesPerView: 4 },
                        '992': { slidesPerView: 4 },
                        '575': { slidesPerView: 3 },
                        '375': { slidesPerView: 1.5 },
                        '320': { slidesPerView: 1.5 },
                    }}
                    pagination={false}
                    modules={[Navigation, Pagination]}
                    className="mySwiper"
                >
                    {
                        Object.values(mostWatchedNewsList).map((newsItem: any, index: number) => {
                            newsItem['routePath'] = buildNewsRoute(newsItem?.id, newsItem?.createdAt, newsItem?.seoDetail?.slugLine, newsItem?.title);
                            return (
                                <SwiperSlide key={index}>
                                    <div className="slider-item" key={index}>
                                        <div className="NewsBox ">
                                            <div className="newsImage">
                                                { // show thmbnail with play icon if video news
                                                    newsItem?.contentType === 'VIDEO' ?
                                                        <>
                                                            <Link href={`/${newsItem?.routePath}`}>
                                                                <a href="#" aria-label="Go to 143">
                                                                    {newsItem?.thumbnail?.url ? <Thumbnail showThumbnail={true} className="img-fluid" src={newsItem?.thumbnail?.url} /> : newsItem?.thumbnail?.path ? <Thumbnail showThumbnail={true} className="img-fluid" src={fileUrl + newsItem?.thumbnail?.path} /> : <Thumbnail showThumbnail={true} className="img-fluid" src={sliderimg.src} />}
                                                                    <div className="PlayTime">
                                                                        <VideoDuration data={newsItem?.video} />

                                                                        <div className="PlayButton-featured_50 PlayButton-base " data-type="play">
                                                                            <span className="PlayButton-flyout">شاهد الآن</span>
                                                                            <span className="icon-play-triangle PlayButton-icon">
                                                                                <i className="fa play_medium"></i>
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                </a>
                                                            </Link>
                                                        </>
                                                        : // else show image
                                                        newsItem?.image?.url ? <Thumbnail showThumbnail={true} className="img-fluid" src={newsItem?.image?.url} /> : newsItem?.image?.path ? <Thumbnail showThumbnail={true} className="img-fluid" src={fileUrl + newsItem?.image?.path} /> : <Thumbnail showThumbnail={true} className="img-fluid" src={sliderimg.src} />
                                                }

                                            </div>
                                            <div className="newscontent">
                                                <h5><Link href={`/${newsItem?.routePath}`}><a href="#" aria-label="Go to 144">{newsItem?.title}</a></Link></h5>
                                                <p>
                                                    <CategoriesLinks categories={newsItem && newsItem?.categories} />
                                                    <b><TimeAgoArabicFormat date={newsItem?.createdAt} /></b>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </SwiperSlide>
                            )
                        })
                    }
                </Swiper>
            </div>
        </>
    )
}

export default MostWatchedSlider